import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';
import { AfterViewInit, Component, computed, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { BaseFormControlComponent } from '../../../classes/base-form-control.component';
import { FormFieldType } from 'src/models/ts/form-field-type.model';
import { CollectionFormField } from '../../../../../../../models/ts/collection-form-field.model';
import { TrnSkillGradeExpiracyStatus } from '../../../../../../../models/ts/trn-skill-grade-expiracy-status.model';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { ArcGaugeModule, CircularGaugeModule } from '@progress/kendo-angular-gauges';
import { FormsModule } from '@angular/forms';
import { GridModule, HeaderModule, SharedModule } from '@progress/kendo-angular-grid';
import { IconComponent } from '../../../../../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../../../../../shared/pipes/translate/translate.pipe';
import { GridComponent } from '@progress/kendo-angular-grid/grid.component';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { asyncScheduler, debounceTime, distinctUntilChanged, filter, map, skip, switchMap, take, tap, zip } from 'rxjs';
import { TrnSkillGradeDto } from '../../../../../../../models/ts/trn-skill-grade-dto.model';
import { UserType } from '../../../../../../../models/ts/user-type.model';
import { TrnFieldProperties } from '../../../../../../../models/ts/trn-field-properties-dto.model';
import { TrainingSubscribedUserDeleteDialogComponent } from './training-subscribed-user-delete-dialog/training-subscribed-user-delete-dialog.component';
import { Dialog } from '@angular/cdk/dialog';
import { selectForm, selectFormFieldByPredicate } from '../../../../../../store/features/forms/forms-selectors';
import { ProtectedCollectionType } from '../../../../../../../models/ts/protected-collection-type.model';
import { UpdateDeleteState } from '../../../../../../../models/ts/update-delete-state.model';
import { TrainingApiService } from '../../../../../../api/bizzmine/training/training-api.service';
import { OrgChartItem } from '../../../../org-chart/interfaces/org-chart-item';
import { OrgChartModalComponent } from '../../../../org-chart/org-chart-modal/org-chart-modal.component';
import { ofType } from '@ngrx/effects';
import { refreshActions } from '../../../../../../store/features/refresh/refresh-actions';
import { OrganizationChartItemType } from '../../../../../../../models/ts/organization-chart-item-type.model';
import { AdditionalModes, OrgChartView } from '../../../../org-chart/org-chart.component';
import { DialogModalModelMode } from '../../../../../../shared/components/modals/dialog-modal/dialog-modal-model';
import { DialogModalComponent } from '../../../../../../shared/components/modals/dialog-modal/dialog-modal.component';
import { formsActions } from '../../../../../../store/features/forms/forms-actions';
import { SafePipe } from 'safe-pipe';
import { resizeLastGridColumn } from 'src/app/shared/components/grid/helpers/resize-last-grid-column';
import { ProtectedFieldType } from 'src/models/ts/protected-field-type.model';
import { DatetimePipe } from '../../../../../..//shared/pipes/dates/datetime.pipe';
import { SignatureDialogComponent } from 'src/app/features/bizzmine/form/components/controls/training-subscribed-users-control/signature-dialog/signature-dialog.component';
import { userSettingsFeature } from 'src/app/store/features/user-settings/user-settings-feature';
import { DateFilterService } from 'src/app/shared/services/filter/date-filter-service';
import { ProtectedFieldValueType } from 'src/models/ts/protected-field-value-type.model';
import { NgClass } from '@angular/common';
import { StepType } from '../../../../../../../models/ts/step-type.model';

@Component({
  selector: 'bizz-training-subscribed-users-control',
  standalone: true,
  imports: [
    CheckBoxModule,
    CircularGaugeModule,
    FormsModule,
    GridModule,
    HeaderModule,
    IconComponent,
    SharedModule,
    TranslatePipe,
    ArcGaugeModule,
    SafePipe,
    NgClass,
    DatetimePipe
  ],
  templateUrl: './training-subscribed-users-control.component.html',
  styleUrl: './training-subscribed-users-control.component.scss'
})
export class TrainingSubscribedUsersControlComponent extends BaseFormControlComponent implements OnInit, AfterViewInit {
  public FormFieldType = FormFieldType;
  public data: CollectionFormField;
  public colors = [
    {
      from: 0,
      color: '#3fad10'
    }
  ];
  public UserType = UserType;
  protected readonly ExpiracyStatus = TrnSkillGradeExpiracyStatus;
  @ViewChild('trainingSubscribedUsersKendoGrid', { read: ElementRef })
  private kendoGridElement: ElementRef;
  @ViewChild('trainingSubscribedUsersKendoGrid')
  private kendoGridComponent: GridComponent;
  private totalGridWidth: number;
  private combinedWidthOfOtherColumns: number;
  private initialLastColumnWidth: number;
  public readonly StepType = StepType;
  public hasLinkedSkill = computed(() => {
    const field = this.store$.selectSignal(selectFormFieldByPredicate(this.formId, (f => f.ProtectedFieldType == ProtectedFieldType.SkillName)))();
    const option = this.store$.selectSignal(selectFormFieldByPredicate(this.formId, (f => f.ProtectedFieldType == ProtectedFieldType.SkillQualificationNoneOption)))();
    if (option?.Value != null) {
      const optionFieldValue = option?.FieldValues?.find(_ => _.CollectionFieldValuesID == option?.Value);
      if (optionFieldValue?.ProtectedFieldValueType == ProtectedFieldValueType.SkillQualificationNone_Qualification) {
        return false;
      }
    }
    return field?.Value != null;
  });

  public isAssessmentStep = computed(() => {
    const form = this.store$.selectSignal(selectForm(this.formId))();
    return form?.data?.StepType == StepType.TrainingAppAssessmentStep;
  });

  public presentChanged(dataItem: TrnFieldProperties): void {
    if (!dataItem.Present) {
      dataItem.SignatureInfo = undefined;
      dataItem.AddToTrainingsQueue = false;
    } else {
      dataItem.AddToTrainingsQueue = undefined;
    }

    this.emitChanged();
  }

  public hasSignatureOption = computed(() => {
    // todo -> when the new protected field has been added -> fetch + get value and determine if it is disabled/required/*optional*
    const field = this.getSignatureRequiredProtectedField();
    if (field) {
      const disabledValue = field.FieldValues?.find(_ => _.ProtectedFieldValueType == ProtectedFieldValueType.SignatureDisabled);
      return field.Value != undefined && field.Value != disabledValue?.CollectionFieldValuesID;
    }
    return false;
  });

  public isSignatureRequired = computed(() => {
    // todo -> when the new protected field has been added -> fetch + get value and determine if it is disabled/required/*optional*
    const field = this.getSignatureRequiredProtectedField();
    if (field) {
      const requiredValue = field.FieldValues?.find(_ => _.ProtectedFieldValueType == ProtectedFieldValueType.SignatureRequired);
      const req = field.Value != undefined && field.Value == requiredValue?.CollectionFieldValuesID;
      return req;
    }
    return false;
  });

  private getSignatureRequiredProtectedField = computed(() => {
    const field = this.store$.selectSignal(selectFormFieldByPredicate(this.formId, (f => f.ProtectedFieldType == ProtectedFieldType.SignatureOptions)))();
    return field;
  });

  public trnSkillGrades: TrnSkillGradeDto[] | undefined;

  public constructor(
    private dialog: Dialog,
    private trainingApiService: TrainingApiService,
    private documentEventsService: DocumentEventsService) {
    super();
    this.actions$.pipe(
      ofType(refreshActions.refreshSkillGrades),
      distinctUntilChanged(),
      filter(props => props?.trainingAppId != null && props.trainingAppId > 0),
      tap(props => {
        this.data.TrainingAppsID = props.trainingAppId;
      }),
      switchMap(props => trainingApiService.getSkillGrades({ trainingAppId: props.trainingAppId })),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((skillgrades) => {
      this.data.TrnSkillGrades = skillgrades;
      this.trnSkillGrades = skillgrades;
    });

    this.documentEventsService.windowResizeEvent.pipe(
      takeUntilDestroyed(this.destroyRef),
      debounceTime(300)
    ).subscribe(() => {
      this.resizeLastGridColumn();
    });
    toObservable(this.isSignatureRequired).pipe(distinctUntilChanged(),skip(1),filter(req => req == true), takeUntilDestroyed(this.destroyRef))
      .subscribe(_ => {
        // if isSignatureRequired changed to true and nothing changes we still need to push values to backend and mark updated
        this.emitChanged();
      });
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.actions$.pipe(ofType(formsActions.updateFormFieldSubscribedUsers), takeUntilDestroyed(this.destroyRef)).subscribe((action) => {
      if (action.fieldId == this.formFieldId()) {
        this.copyData(this.formFieldSignal()!);
      }
    });
    this.actions$.pipe(ofType(formsActions.updateTrainingAssessment), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.copyData(this.formFieldSignal()!);
      }
    );

    const field = this.formFieldSignal();
    if (field) {
      this.copyData(field);
    }
  }

  private copyData(found: CollectionFormField): void {
    this.data = structuredClone(found);
    this.data.TrnUsers = this.data.OrgChartUnitSelector.map(o => o.TrnUser);
    this.data.TrnUsers.forEach(user => {
      if (user.SignatureInfo?.Signature == '') {
        user.SignatureInfo = undefined;
      }
    });
  }

  public override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    asyncScheduler.schedule(() => {
      this.kendoGridComponent.columnResize.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.resizeLastGridColumn();
      });
      this.resizeLastGridColumn();
    });
  }

  public delete(trainee: TrnFieldProperties): void {
    this.dialog.open<boolean | undefined>(TrainingSubscribedUserDeleteDialogComponent, {
      data: { trainee }
    })
      .closed.subscribe((result) => {
      if (result != undefined) {
        if (result) {
          this.data.TrnDeletedUsers = this.data.TrnDeletedUsers ?? [];
          this.data.TrnDeletedUsers.push(trainee);
        }
        this.data.TrnUsers = this.data.TrnUsers.filter(x => x.ID != trainee.ID);
        this.data.OrgChartUnitSelector = this.data.OrgChartUnitSelector.filter(x => x.VersionId != trainee.ID);
        this.emitChanged();
      }
    });
  }

  private timeZoneName = this.store$.selectSignal(
    userSettingsFeature.selectTimezoneName
  );

  private dateFilterService = inject(DateFilterService);

  public gatherSignature(user: TrnFieldProperties): void {
    this.dialog.open<{ data: string | undefined } | undefined>(SignatureDialogComponent, {
      data: {
        signature: user.SignatureInfo?.Signature,
        sessionName: 'Ja',
        userName: `${user.Name}`,
        readOnly: this.data.IsReadOnly || this.readOnlyOverride || this.isAssessmentStep()
      }
    })
      .closed
      .pipe(
        take(1))
      .subscribe(result => {
        if (result) {
          user.SignatureInfo = undefined;
          if (result.data) {
            user.SignatureInfo = {
              Signature: result.data,
              Date: this.dateFilterService.calculateDateWithTimezoneAndDst(this.timeZoneName(), new Date(Date.now()))
            };
          }
        }
        this.emitChanged();
      });
  }

  public getScore(skillGradeId: number, defaultValue: boolean): TrnSkillGradeDto | null {
    const scores = this.trnSkillGrades ?? this.data.TrnSkillGrades;
    if (!this.data || !scores || scores.length == 0) {
      return null;
    }

    const found = scores.find(x => x.ID == skillGradeId);
    if (found) {
      return found;
    }
    if (defaultValue) {
      return this.data.TrnSkillGrades[0];
    }
    return null;
  }

  public addUser(): void {
    let hasTraining = false;
    const form = this.store$.selectSignal(selectForm(this.formId))();
    const viewDataSources = form?.data?.ViewDataSources;
    let training: number | undefined = undefined;
    if (viewDataSources) {
      const trainingInstances = viewDataSources.find(x => x.ProtectedCollectionType == ProtectedCollectionType.LinkTrainingTrainingsessions)?.Instances;

      if (trainingInstances == null || trainingInstances.length == 0) {
        hasTraining = false;
      } else {
        const trainingInstance = trainingInstances.find(el => el.State != UpdateDeleteState.Delete);

        if (trainingInstance == null) {
          hasTraining = false;
        } else {
          hasTraining = true;
          training = trainingInstance.ChildVersionsID; // incorrect, should be skillversionsID (can be 0 if no skill)
        }
      }

      if (hasTraining) {
        this.dialog.open<Array<OrgChartItem>>(OrgChartModalComponent, {
          data: {
            excludeExternalUsers: false,
            allowedItemTypes: [OrganizationChartItemType.User],
            additionalModes: [{
              additionMode: AdditionalModes.TRAINING_QUEUE,
              data: { trainingId: training!, trainingAppId: this.data.TrainingAppsID }
            }],
            activeView: OrgChartView.TRAINEES
          }
        })
          .closed.subscribe((result) => {
          if (result && training) {
            const trainees$ = result.filter(r => this.data.TrnUsers.find(t => t.ID == r.VersionId) == undefined).map(user => this.trainingApiService.getTrainee({
              userId: user.VersionId,
              trainingAppId: this.data.TrainingAppsID,
              skillVersionId: training!
            }).pipe(take(1), map(found => {
              user.TrnUser = {
                ID: user.VersionId,
                Expiracy: found?.Expiracy,
                Grade: found?.SkillGradeID,
                Name: user.Name,
                Present: true,
                Remarks: ''
              };

              return { trainee: found, user };
            })));
            zip(trainees$).subscribe(found => {
              found.forEach(({ trainee, user }) => {

                this.data.TrnUsers.push({
                  ID: user.VersionId,
                  Expiracy: trainee?.Expiracy,
                  Grade: trainee?.SkillGradeID,
                  Name: user.Name,
                  Present: true,
                  Remarks: ''
                });

                this.data.OrgChartUnitSelector.push(user);
              });
              this.emitChanged();
            });
          }
        });

      } else {
        this.dialog.open(DialogModalComponent, {
          data: {
            mode: DialogModalModelMode.simple,
            title: 'NoTraining',
            message: 'NoTrainingFound',
            confirmationtext: '',
            showCancelButton: true
          }
        });

      }
    }
  }

  public emitChanged(): void {
    const fieldId = this.formFieldId();
    if (fieldId) {
      this.store$.dispatch(formsActions.updateFormFieldSubscribedUsers({
        formId: this.formId,
        fieldId: fieldId,
        users: this.data.TrnUsers,
        deletedUsers: this.data.TrnDeletedUsers,
        orgChart: this.data.OrgChartUnitSelector
      }));
    }

  }

  private resizeLastGridColumn(): void {
    if (this.kendoGridElement == undefined || this.kendoGridComponent == undefined) {
      throw new Error('kendoGridElement is undefined');
    }
    resizeLastGridColumn(this.kendoGridComponent.columns.toArray(),
      this.totalGridWidth,
      this.kendoGridComponent.group?.length ?? 0,
      this.initialLastColumnWidth);
  }

  // Implement the abstract member from TrainingSubscribedUsersControlComponent
  protected override focus(): void {
    // Add your implementation here
  }
}